import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Holly fuck",
  "description": "",
  "published": "2007-05-10T00:00:00.000Z",
  "redirect_from": ["/blog/holly-fuck/swizec/215"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Short blog today because, frankly, I'm too lazy to talk as my back is killing me for some reason ... bloody gym. Anyway, in the small hours of the morning the`}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=show_comics/comic=7"
      }}>{` comic`}</a>{` for March has been released into the wild. Only a wee bit late ... just some three months. There also probably will not be another update until at least October.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      